import { RegionShared } from "@1games-ru/region-shared";
import { EventDirection } from "@1games-ru/region-shared/dist/enums/target-menu/target-menu";
import { useCallback, useEffect, useMemo, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default () => {
  const [menu, setMenu] = useState<null | typeof RegionShared.Types.TargetMenu.MenuAnchor>(null);
  const [nestedItems, setNestedItems] = useState<
    (typeof RegionShared.Types.TargetMenu.MenuItem)[] | null
  >(null);

  const changeItems = useCallback(
    (value: (typeof RegionShared.Types.TargetMenu.MenuItem)[] | null) => {
      setNestedItems(value);
    },
    [],
  );

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.TargetMenu.Show,
      (state: typeof RegionShared.Cef.Requests.TargetMenuShowRequest) => {
        setMenu(state.menuAnchor);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.TargetMenu.Show);
    };
  }, []);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.TargetMenu.Hide,
      (hideRequest: typeof RegionShared.Cef.Requests.TargetMenuHideRequest) => {
        if (hideRequest.isInstanceClose || !nestedItems) {
          setMenu(null);
          setNestedItems(null);

          return { isClosed: true };
        }

        setNestedItems(null);

        return { isClosed: false };
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.TargetMenu.Hide);
    };
  }, [nestedItems]);

  const menuItems = useMemo(() => {
    return nestedItems || menu?.items || [];
  }, [menu, nestedItems]);

  const handleClose = useCallback(async () => {
    setMenu(null);
    setNestedItems(null);
    await rpc.callClient(RegionShared.Client.Events.TargetMenu.Hide, {});
  }, []);

  const handleClick = useCallback(
    async ({
      eventName,
      eventDirection,
      eventPayload,
    }: typeof RegionShared.Types.TargetMenu.MenuItem) => {
      try {
        if (!eventName) {
          return;
        }

        const eventArgument = eventPayload ?? menu.entityId;

        switch (eventDirection) {
          case EventDirection.Cef: {
            await rpc.call(eventName, eventArgument);
            break;
          }
          case EventDirection.Client: {
            await rpc.callClient(eventName, eventArgument);
            break;
          }
          case EventDirection.Server: {
            await rpc.callServer(eventName, eventArgument);
            break;
          }
          default:
            break;
        }
        await handleClose();
      } catch (error) {
        console.log(error);
      }
    },
    [menu],
  );

  return { handleClick, handleClose, menuItems, changeItems, menu, nestedItems };
};
